"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    radioSizes: ()=>radioSizes,
    RadioDisabledStateVariants: ()=>RadioDisabledStateVariants,
    radioSizeVariants: ()=>radioSizeVariants,
    RadioEmphasisVariants: ()=>RadioEmphasisVariants,
    radioButtonVariants: ()=>radioButtonVariants,
    radioEmphases: ()=>radioEmphases
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const radioSizeVariants = {
    16: {
        labelSlot: 'text-body3',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[6px] before:h-[6px]'
    },
    20: {
        labelSlot: 'text-body2',
        radioRoot: 'w-4 h-4',
        radioIndicator: 'before:w-[8px] before:h-[8px]'
    },
    24: {
        labelSlot: 'text-body1',
        radioRoot: 'w-6 h-6',
        radioIndicator: 'before:w-[10px] before:h-[10px]'
    }
};
const radioSizes = Object.keys(radioSizeVariants);
const RadioEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1 border border-primary-6 ',
            'hover:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    medium: {
        labelSlot: 'text-primary-13',
        radioRoot: [
            'bg-primary-1/60 border border-primary-6',
            'hover:border-primary-10 focus-visible:outline-primary-8',
            'data-checked:bg-primary-8 data-checked:border-primary-8',
            'hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9'
        ],
        radioIndicator: 'data-checked:before:bg-primary-1 data-disabled:data-checked:before:bg-primary-6',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    },
    bold: {
        labelSlot: 'text-primary-1',
        radioRoot: [
            'bg-primary-1/20 border border-primary-1/40',
            'hover:border-primary-1 focus-visible:outline-primary-1',
            'data-checked:bg-primary-1 data-checked:border-primary-1',
            'hover:data-checked:bg-primary-1/80  hover:data-checked:border-primary-1/80'
        ],
        radioIndicator: 'data-checked:before:bg-primary-8 data-disabled:data-checked:before:bg-primary-1/40',
        helperSlot: 'text-primary-1 group-[.disabled]:text-primary-1/40',
        textRightSlot: 'text-primary-10 group-[.disabled]:text-primary-1/40'
    }
};
const RadioDisabledStateVariants = {
    false: {
        containerSlot: 'group',
        labelSlot: 'hover:before:bg-primary-2 relative cursor-pointer before:absolute before:inset-0 before:-z-[1] before:rounded-xl before:border-0 before:transition before:duration-300',
        helperSlot: 'hover:before:bg-primary-2 text-primary-13 relative cursor-pointer before:absolute before:inset-0 before:-z-[1] before:-m-2 before:rounded-xl before:border-0 before:transition before:duration-300',
        textRightSlot: 'cursor-pointer text-primary-10'
    },
    true: {
        containerSlot: 'group disabled:cursor-not-allowed',
        labelSlot: 'has-disabled:cursor-not-allowed',
        helperSlot: 'text-primary-6 has-disabled:cursor-not-allowed',
        textRightSlot: 'text-primary-6 has-disabled:cursor-not-allowed',
        imageSlot: 'has-disabled:cursor-not-allowed'
    }
};
const radioEmphases = Object.keys(RadioEmphasisVariants);
const radioButtonVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        containerSlot: 'has-disabled:cursor-not-allowed flex flex-1 flex-col items-start text-left',
        labelSlot: 'has-disabled:cursor-not-allowed hover:bg-primary-2 items-normal flex items-center gap-2 rounded-md border-4 border-solid border-transparent text-left leading-tight',
        radioRoot: 'hover:shadow-input-hover data-checked:transition inline-flex cursor-pointer items-center justify-center rounded-full transition focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:shadow-none',
        radioIndicator: 'data-unchecked:hidden data-checked:transition flex transition before:rounded-full',
        iconSlot: 'no-underline transition hover:no-underline group-hover:no-underline',
        helperSlot: 'has-disabled:cursor-not-allowed text-body3 display-block items-normal flex w-full text-left leading-tight',
        textRightSlot: 'has-disabled:cursor-not-allowed text-body3 text-primary-10 flex justify-end pt-0',
        imageSlot: 'has-disabled:cursor-not-allowed inline-block self-center overflow-hidden bg-gray-50'
    },
    variants: {
        emphasis: RadioEmphasisVariants,
        size: radioSizeVariants,
        disabled: RadioDisabledStateVariants,
        isRadioGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isRadioGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full py-1'
            }
        },
        {
            disabled: true,
            emphasis: 'regular',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'bg-primary-2 border-primary-5 hover:border-primary-5',
                    'data-checked:bg-primary-2 data-checked:border-primary-2',
                    'hover:data-checked:bg-primary-2 hover:data-checked:border-primary-2'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'medium',
            class: {
                labelSlot: 'text-primary-6',
                radioRoot: [
                    'bg-primary-1/60 border-primary-5 hover:border-primary-5',
                    'data-checked:bg-primary-1/60 data-checked:border-primary-1/60',
                    'hover:data-checked:bg-primary-1/60 hover:data-checked:border-primary-1/60'
                ]
            }
        },
        {
            disabled: true,
            emphasis: 'bold',
            class: {
                labelSlot: 'text-primary-1/40',
                radioRoot: [
                    'bg-primary-1/20 border-primary-1/20 hover:border-primary-1/20',
                    'data-checked:bg-primary-1/20 data-checked:border-primary-1/20',
                    'hover:data-checked:bg-primary-1/20 hover:data-checked:border-primary-1/20'
                ]
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        disabled: false,
        isRadioGroup: false,
        layout: 'vertical'
    }
});
exports.RadioDisabledStateVariants = __webpack_exports__.RadioDisabledStateVariants;
exports.RadioEmphasisVariants = __webpack_exports__.RadioEmphasisVariants;
exports.radioButtonVariants = __webpack_exports__.radioButtonVariants;
exports.radioEmphases = __webpack_exports__.radioEmphases;
exports.radioSizeVariants = __webpack_exports__.radioSizeVariants;
exports.radioSizes = __webpack_exports__.radioSizes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "RadioDisabledStateVariants",
    "RadioEmphasisVariants",
    "radioButtonVariants",
    "radioEmphases",
    "radioSizeVariants",
    "radioSizes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
